import type {
  CopilotAnnotation,
  CopilotAnnotationItem,
  CodeInsightsInfo,
  PublicCodeReferenceInfo,
} from '../types/code-insights-metadata'

function extractNwoFromURL(url: string): string | undefined {
  try {
    const urlObj = new URL(url, 'https://github.com')
    // Extract path segments, typically: /owner/repo/...
    const pathParts = urlObj.pathname.split('/').filter(Boolean)
    if (pathParts.length >= 2) {
      return `${pathParts[0]}/${pathParts[1]}`
    }
    return undefined
  } catch {
    return undefined
  }
}

function mapCopilotAnnotationItemToPublicCodeReference(
  item: CopilotAnnotationItem | null | undefined,
): PublicCodeReferenceInfo | undefined {
  const citations = item?.citations
  if (!citations || !citations.url) {
    return undefined
  }

  return {
    annotationId: item.id,
    sourceURL: citations.url,
    license: citations.license || undefined,
    language: undefined, // Not available in the raw annotation format
    nwo: extractNwoFromURL(citations.url),
  }
}

export function parseCopilotAnnotationsToCodeInsights(copilotAnnotations: unknown): CodeInsightsInfo | undefined {
  if (!copilotAnnotations) {
    return undefined
  }

  let parsed: CopilotAnnotation
  try {
    parsed = typeof copilotAnnotations === 'string' ? JSON.parse(copilotAnnotations) : copilotAnnotations
  } catch {
    return undefined
  }

  const publicCodeReferences = Object.values(parsed)
    .flat()
    .flatMap(item => {
      const ref = mapCopilotAnnotationItemToPublicCodeReference(item)
      return ref ? [ref] : []
    })

  return publicCodeReferences.length > 0 ? {publicCodeReferences} : undefined
}
